import { createTheme, MantineTheme, rem } from '@mantine/core';

import '@fontsource/agdasima';
import '@fontsource/roboto';

export const theme = createTheme({
  colors: {
    principal: [
      '#eeffe5',
      '#deffce',
      '#bdfe9d',
      '#9afd68',
      '#7cfc3c',
      '#5efc12',
      '#4de003',
      '#41c700',
      '#4ee303',
      '#31ac00',
    ],
  },
  fontFamily: 'Roboto, sans-serif',
  headings: {
    fontFamily: 'Agdasima, sans-serif',
  },

  components: {
    TextInput: {
      styles: (theme: MantineTheme) => ({
        input: {
          '&:focus, &:focus-within': {
            borderColor: theme.colors.principal[5],
            outline: `${rem(2)} solid ${theme.colors.principal[5]}`,
          },
        },
      }),
    },
    Input: {
      styles: (theme: MantineTheme) => ({
        input: {
          '&:focus, &:focus-within': {
            borderColor: theme.colors.principal[5],
            outline: `${rem(2)} solid ${theme.colors.principal[5]}`,
          },
        },
      }),
    },

    Select: {
      styles: (theme: MantineTheme) => ({
        input: {
          '&:focus, &:focus-within': {
            borderColor: theme.colors.principal[5],
            outline: `${rem(2)} solid ${theme.colors.principal[5]}`,
          },
        },
      }),
    },
    Textarea: {
      styles: (theme: MantineTheme) => ({
        input: {
          '&:focus, &:focus-within': {
            borderColor: theme.colors.principal[5],
            outline: `${rem(2)} solid ${theme.colors.principal[5]}`,
          },
        },
      }),
    },
  },
});
